import { orderBy } from "es-toolkit";

import type { InteractModuleListItem } from "@skilitics/nautilus-endpoint-definition";

import type { OrderingDirection } from "../types.ts";

const ascendingPlacement = Array.from({ length: 32 })
  .map(() => "z")
  .join("");

const descendingPlacement = "";

export const createByTags = (orderingDirection: OrderingDirection) => (modules: InteractModuleListItem[]) =>
  modules
    ? orderBy(
        modules,
        [
          ({ tags }) =>
            tags.length
              ? tags.map((tag) => tag.toLowerCase()).join(", ")
              : orderingDirection === "ascending"
                ? ascendingPlacement
                : descendingPlacement,
        ],
        [orderingDirection === "ascending" ? "asc" : "desc"],
      )
    : [];
